<template>
  <div class="interaction">
    <el-dialog :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="interaction-head">{{ doubleCheck ? '重新选择决策' : '系统决策' }}</div>
      <div class="interaction-box" :class="eventResultColor" v-if="!doubleCheck">
        <div class="makepolicy-head">基于系统建议决策：<span>{{ dataRow.resultComment }}</span>
        </div>
        <div class="makepolicy-box">
          <div class="makepolicy-h">基于以下原因作出判断：</div>
          <div class="makepolicy-li" v-for="(item,index) in dataRow.hints" :key="index">{{ item }}</div>
        </div>
        <div class="makepolicy-laber" v-show="dataRow.tip!==''">{{ dataRow.tip }}</div>
      </div>
      <div class="bt-box" v-if="!doubleCheck">
        <div class="bt2" v-if="this.dataRow.options" @click="doubleCheck = true">不同意并重新决策</div>
        <div class="bt" @click="agree()">{{ this.dataRow.options ? '同意并采纳' : '确认' }}</div>
      </div>
      <div class="interaction-box" v-if="doubleCheck">
        <div class="interaction-li">
          <div class="interaction-left active">选择结论：</div>
          <div class="interaction-right">
            <div class="evaluation-click">
              <el-radio v-model="socResult" v-for="item in dataRow.options" :key="item.value" :label="item.value">
                {{ item.comment }}
              </el-radio>
            </div>
          </div>
        </div>
        <div class="interaction-li" v-if="socResult==='R3'">
          <div class="interaction-left"><span style="color: red"> * </span> 具体方案：</div>
          <div class="interaction-right">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="socResultCustomComment" maxlength="255"></el-input>
          </div>
        </div>
      </div>
      <div class="bt-box" v-if="doubleCheck">
        <div class="bt2" @click="doubleCheck = false">返回系统决策</div>
        <div class="bt" @click="agree()">提交决策</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {agreeSystem, finishTask} from "@/api/kecang";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: String,
      required: true
    },
    eventType: {
      type: String,
      required: true
    },
    dataRow: {
      type: Object,
      required: true
      // {
      // "result": "R1",
      // "resultComment": "快速撤离",
      // "title": "系统决策建议",
      // "tip": "请指挥旅客快速撤离，并随时监控是否出现明火，完成检查单项目。",
      // "hints": ["确定出现试图纵火的行为", "无人员反馈到明火或烟雾"],
      // "options": [
      //   {"value": "R1", "comment": "快速撤离"},
      //   {"value": "R2", "comment": "紧急撤离"},
      //   {"value": "R3", "comment": "公司决策"}
      // ]
      // }
    }
  },
  data() {
    return {
      doubleCheck: false,
      socResult: this.dataRow.result,
      socResultCustomComment: this.dataRow.socResultCustomComment,
      rules:{
        socResultCustomComment: [
          {required: true, message: '请输入原密码', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    eventResultColor() {
      // return '' // 黄色
      // return 'active2' // 红色
      // return 'active3' // 蓝色
      // return 'active' // 绿色
      switch (this.eventType) {
        case 'CET0': // 纵火
          // R1("快速撤离", "请指挥旅客快速撤离，并随时监控是否出现明火，完成检查单项目。", new String[]{"确定出现试图纵火的行为", "无人员反馈到明火或烟雾"}),
          // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"出现客舱纵火行为", "可观察到明火或烟雾"}),
          // R3("公司决策", "", new String[]{}),
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R2' :
              return 'active2' // 红色
            case 'R3' :
              return 'active3' // 蓝色
          }
          break
        case 'CET1': // 斗殴
          // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现斗殴的行为", "无人员反馈到严重的事态行为"}),
          // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现斗殴的行为", "已出现严重的事态行为"}),
          // R3("公司决策", "", new String[]{}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R2' :
              return 'active2' // 红色
            case 'R3' :
              return 'active3' // 蓝色
            case 'R4' :
              return 'active' // 绿色
          }
          break
        case 'CET2': // 劫炸机威胁
          // R1("立即滑回防爆停机位", "请立即滑回防爆停机位，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"已出现严重的事态行为"}),
          // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"存在爆炸物风险"}),
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R2' :
              return 'active2' // 红色
          }
          break
        case 'CET3': // 违规使用电子/应急设备
          // R1("创造条件起飞", "请尽可能创造起飞条件，并完成检查单项目。", new String[]{"确认违规使用电子/应急设备事件"}),
          // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确认违规使用电子/应急设备事件", "已出现影响通讯情况", "已出现故障警告情况", "已出现开启或损坏紧急设备情况"}),
          // R3("公司决策", "", new String[]{}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R2' :
              return 'active2' // 红色
            case 'R3' :
              return 'active3' // 蓝色
            case 'R4' :
              return 'active' // 绿色
          }
          break
        case 'CET4': // 冲击驾驶舱
          // R1("立即滑回", "请立即滑回，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"确定出现冲击驾驶舱行为"}),
          // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现冲击驾驶舱行为", "已出现严重的事态行为"}),
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R2' :
              return 'active2' // 红色
          }
          break
        case 'CET5': // 机上吸烟
          // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现机上吸烟行为", "无人员反馈到严重的事态行为"}),
          // R2("事件转变", "", new String[]{""}),
          // R3("-", "", new String[]{""}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R4' :
              return 'active' // 绿色
          }
          break
        case 'CET6': // 冲击机场/拒不下机
          // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现冲击机场拒不下机行为", "无人员反馈到严重的事态行为"}),
          // R2("事件转变", "", new String[]{""}),
          // R3("-", "", new String[]{""}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R4' :
              return 'active' // 绿色
          }
          break
        case 'CET0': // 劫炸机
          switch (this.dataRow.result) {
            case 'R1' :
              return '' // 黄色
            case 'R2' :
              return 'active2' // 红色
            case 'R3' :
              return 'active3' // 蓝色
          }
          break
      }
      return ''
    }
  },
  methods: {
    async agree() {
      if ('R3' === this.socResult && '' === (this.socResultCustomComment || '').trim()) {
        this.$message.warning('请输入具体方案')
        return
      }
      if (this.dataRow.options && this.dataRow.options.length > 0) {
        const obj = {
          eventId: this.eventId,
          type: this.eventType,
          socResult: this.socResult,
          socResultCustomComment: this.socResultCustomComment
        }
        const res = await agreeSystem(obj)
        if (res.code === 'A00000') {
          this.$message.success('提交成功')
        } else {
          this.$message.error(res.message)
        }
      } else {
        const res = await finishTask(this.eventId, this.eventType)
        if ('A00000' === res.code) {
          this.$message.success('提交成功')
          this.handleClose()
        } else {
          this.$message.error('提交失败')
        }
      }
    }
  }

}
</script>

<style lang="less" scoped>

/*6666666666666666*/
.interaction-box.active {
  .makepolicy-li:before {
    background: #5CBE85 !important;
  }

  .makepolicy-head span {
    color: #5CBE85 !important;
  }

  .makepolicy-laber {
    color: #5CBE85;
    background: rgba(92, 190, 133, 0.1);
  }
}

.interaction-box.active2 {
  .makepolicy-li:before {
    background: #E9463C !important;
  }

  .makepolicy-head span {
    color: #E9463C !important;
  }

  .makepolicy-laber {
    color: #E9463C;
    background: rgba(233, 70, 60, 0.1);
  }
}

.interaction-box.active3 {
  .makepolicy-li:before {
    background: #3F7CF6 !important;
  }

  .makepolicy-head span {
    color: #3F7CF6 !important;
  }

  .makepolicy-laber {
    color: #3F7CF6;
    background: rgba(39, 105, 236, 0.1);
  }
}

.interaction-box {
  .makepolicy-head {
    font-size: 18px;
    color: #fff;

    span {
      color: #EBA967;
    }
  }

  .makepolicy-box {
    background: #393F52;
    border-radius: 8px;
    padding: 16px;
    margin-top: 12px;

    .makepolicy-h {
      opacity: 0.6;
      font-size: 16px;
    }

    .makepolicy-li:before {
      content: '';
      display: block;
      position: absolute;
      width: 6px;
      height: 6px;
      background: #EBA967;
      border-radius: 50%;
      left: 0;
      top: 8px;
    }

    .makepolicy-li {
      color: rgba(255, 255, 255, 0.87);
      font-size: 16px;
      margin-top: 12px;
      padding-left: 18px;
      position: relative;
    }
  }

  .makepolicy-laber {
    background: rgba(233, 146, 60, 0.1);
    border-radius: 4px;
    height: 32px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    color: #EBA967;
    margin-top: 16px;
  }

  padding: 24px;

  .interaction-li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;

    .interaction-left {
      width: 150px;
      text-align: left;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.87);
    }

    .interaction-left.active {
      line-height: 48px;
    }

    .interaction-right {
      flex: 1;
      position: relative;

      .evaluation-click {
        line-height: 48px;
      }
    }
  }
}

.interaction-head {
  font-size: 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modalclose {
  position: absolute;
  width: 20px;
  top: 22px;
  right: 16px;
  cursor: pointer;
}

/deep/ .interaction .el-dialog__header {
  display: none;
}

/deep/ .interaction .el-dialog {
  position: absolute;
  margin-top: 0 !important;
  background: url("~@/assets/images/index/xian.png") no-repeat #262D40;
  background-size: 100% 100%;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  width: 600px;
  left: calc(50% - 300px);
  top: calc(30%);
  border-radius: 8px;
  padding-bottom: 24px;

  .el-input__inner {
    height: 48px;
    background: #262D40;
    border: 1px solid #525F89;
    border-radius: 8px;
    color: #fff;
  }

  .el-textarea__inner {
    background: #393F52;
    border-radius: 8px;
    border: none;
    padding: 10px;
    height: 168px;
    color: #fff;
    font-size: 16px;
  }

  .el-select {
    width: 100%;
  }
}

/deep/ .interaction .el-dialog__body {
  padding: 0;
  text-align: left;
  color: #fff;
}

.bt-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;

  .bt {
    border-radius: 8px;
    flex: 1;
    margin: 0;
    height: 44px;
  }

  .bt2 {
    border-radius: 8px;
    width: 258px;
    margin-right: 24px;
    height: 44px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/SocConfirmDialog.vue